var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6282 14.852L15.3104 12.2283L14.7192 11.6399L12.6282 13.6884L11.7262 12.7735L11.1341 13.3665L12.6282 14.852ZM2.61611 4.43956H12.4969V3.50116H2.61517L2.61611 4.43956ZM13.2222 17C12.1701 17 11.2776 16.6356 10.5447 15.9068C9.8112 15.1786 9.44444 14.2918 9.44444 13.2464C9.44444 12.201 9.8112 11.3139 10.5447 10.5851C11.2782 9.8563 12.1707 9.4922 13.2222 9.49282C14.2737 9.49345 15.1665 9.85755 15.9007 10.5851C16.6348 11.3127 17.0013 12.1998 17 13.2464C17 14.2912 16.6336 15.1779 15.9007 15.9068C15.1665 16.6356 14.2737 17 13.2222 17ZM0 15.736V0H15.1111V7.09428C14.9575 7.03798 14.8051 6.98981 14.654 6.94977C14.5023 6.90973 14.3398 6.87845 14.1667 6.85593V0.938397H0.944444V14.1229H6.936C6.97881 14.3794 7.03422 14.6302 7.10222 14.8755C7.17085 15.1207 7.26624 15.3547 7.38839 15.5774L7.35628 15.6093L6.28433 14.8342L5.01311 15.736L3.74189 14.8342L2.47067 15.736L1.1985 14.8342L0 15.736ZM2.61611 11.5132H7.0635C7.09876 11.3412 7.1422 11.1801 7.19383 11.0299C7.24546 10.8798 7.30591 10.7281 7.37517 10.5748H2.61611V11.5132ZM2.61611 7.97637H9.52C9.82852 7.73427 10.1591 7.53251 10.5117 7.37111C10.8643 7.20908 11.2411 7.09804 11.6422 7.03798H2.61517L2.61611 7.97637Z",
    fill: "#E2E2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDark);
export default __webpack_public_path__ + "static/media/order-dark.729683591b821394b82843099bff4434.svg";
export { ForwardRef as ReactComponent };